import React from "react";

const PageTitle = ({ text }) => (
  <h1 className="text-3xl lg:text-5xl font-serif mb-6 leading-tight">{text}</h1>
);

export default PageTitle;
